import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/profile_attribute_resource.rb
const ProfileAttributeSchema = withDefaults({
  type: 'profile-attribute',
  fields: [
    { kind: 'attribute', name: 'userAttributeKey' },
    { kind: 'attribute', name: 'userAttributeValue' },
    { kind: 'attribute', name: 'usedReferenceData' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'belongsTo', name: 'user', type: 'user', options: { async: false, inverse: null } },
  ],
});

export default ProfileAttributeSchema;
